import type { DeviceDto, NodeDto } from './types';

/*
 * „Hat dieses Device schon einen Baum?" — eine Antwort, nicht drei.
 *
 * Der Apply-Endpoint für Schema-Templates antwortet mit 409 (TargetNotEmpty),
 * wenn unter dem Device noch Nodes oder Leaves hängen. Die UI muss das vorher
 * wissen, um die Overwrite-Rückfrage überhaupt zu stellen — sonst läuft der
 * Operator in einen 409, den er nicht erwartet hat.
 *
 * Es gibt dafür auch den Server-Endpoint `device-schema-presence` (den
 * ScanCandidatesPage nutzt, weil sie den Baum selbst nicht lädt). Wo der Baum
 * ohnehin schon im Speicher liegt (PlantSchemaResponse), ist ein zweiter
 * Request Verschwendung — dann zählt man ihn hier.
 */

/** Nodes + Leaves in einem Teilbaum. */
export function countSchemaEntries(nodes: readonly NodeDto[]): number {
  let total = 0;
  for (const node of nodes) {
    total += 1 + node.leaves.length + countSchemaEntries(node.children);
  }
  return total;
}

/**
 * True wenn unter dem Device weder Node noch Leaf hängt — dann darf ein
 * Template-Apply ohne Overwrite-Bestätigung laufen.
 */
export function isDeviceSchemaEmpty(device: Pick<DeviceDto, 'nodes'> | null | undefined): boolean {
  if (!device) return true;
  return countSchemaEntries(device.nodes) === 0;
}
